import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import styled, { css } from 'styled-components';
import fontSize from '../../styles/settings/fontSize';

export const DialogModal = styled(Dialog)`
  &.dialog-parent {
    .MuiDialog-paper {
      ${(props) =>
        props.widthContainer > 0 &&
        css`
          max-width: ${props.widthContainer + 0.1}px!important;
          width: ${props.widthContainer}px;
        `}
    }
  }
`;

export const DialogContainer = styled.div`
  background: ${(props) => props.widhtContainer || 'auto'};
  padding: 8px;

  .margin-container {
    border: 1px solid ${(props) => props.borderColor || '#C4C4C4'};

    .MuiDialogTitle-root {
      padding: 2px 0;
    }
  }
`;

export const Title = styled(DialogTitle)`
  align-items: center;
  background: ${(props) => props.bgColor || '#fff'};
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: ${(props) => (props.heightTitle ? 0 : '2px 0')};

  span {
    color: ${(props) => props.color || '#000'};
    display: block;
    font-size: ${(props) => (props.fontTitle > 0 ? props.fontTitle : 22)}px;
    font-weight: normal;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
      'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    text-align: center;
  }
`;

export const BodyText = styled(DialogContent)`
  background: ${(props) => props.bgColor || '#fff'};
  height: ${(props) => props.height || '#fff'};
  display: flex;
  justify-content: center;

  .message-html {
    font-size: ${(props) =>
      props.messageFontSize ? `${props.messageFontSize}px` : fontSize.button};
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
      'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  }

  p {
    align-items: center;
    color: ${(props) => props.color || '#000'};
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 0;
  }
`;

export const DialogActionsMessage = styled(DialogActions)`
  background: ${(props) => props.backgroundColor || '#fff'};
  justify-content: center !important;
`;
